import SEQ from '@/API/logurl';

let loggerInstance1 = null;

// Logger를 비동기 로딩해서 미리 초기화해두는 함수
export async function initializeLogger() {
    const { Logger } = await import('seq-logging');
    loggerInstance1 = new Logger({
        serverUrl: SEQ.SERVER1_URL,
        apiKey: SEQ.SERVER1_KEY,
    });
}

// 로그 전송용 함수
export function sendLog1(level = 'log', message = 'no message', properties = {}) {
    if (!loggerInstance1) {
        console.warn('logger가 아직 초기화되지 않았습니다!');
        return;
    }

    let LEVEL = level.toLowerCase();
    switch (LEVEL) {
        case 'warn':
            LEVEL = 'Warning';
            break;
        case 'error':
            LEVEL = 'Error';
            break;
        default:
            LEVEL = 'Information';
            break;
    }

    loggerInstance1.emit({
        timestamp: new Date(),
        level: LEVEL,
        messageTemplate: message,
        properties: properties,
    });
}
